export const environment = {
  envName: 'uat',
  production: false,
  companyRedirectUrl: 'https://mobeus-uat.com',
  browserLinkUrl: 'https://endless.pizza'
};
